import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

export const InnerWrapper = styled.div`
  display: inline-block;
  width: 100%;
  padding-bottom: 90px;
`;

export const ActivityWrapper = styled.div`
  width: calc(75% - 10px);
  float: left;
  ${media.l`
    width: calc(73% - 10px);
  `};
  ${media.m`
    width: 100%;
  `};
`;

export const Blured = styled.div`
  width: 100%;
  height: 30px;
  position: sticky;
  top: 60px;
  background-color: ${props => props.theme.color.wfWhite};
  opacity: 0.8;
  z-index: 10;
`;

export const Sticky = styled.div`
  position: sticky;
  top: ${props => (props.hasBanner ? '116px' : props.theme.spacing.default)};
  z-index: 10;
  ${media.s`
    top: ${props => (props.hasBanner ? '136px' : props.theme.spacing.default)};
  `};
`;

export const SidebarWrapper = styled.div`
  width: calc(25% - 10px);
  float: right;
  margin-right: 2px;
  margin-top: 30px;
  position: sticky;
  top: ${props => (props.hasBanner ? '116px' : props.theme.spacing.default)};
  ${media.s`
    top: ${props => (props.hasBanner ? '136px' : props.theme.spacing.default)};
  `};
  ${media.l`
    width: calc(27% - 10px);
  `};
  ${media.m`
    display: none;
  `};
`;

export const Sidebar = styled.div`
  width: 100%;
  margin-bottom: 14px;
  border: 1px solid ${props => props.theme.color.wfGrey300};
`;

export const SidebarItem = styled.h3`
  font-size: 0.925em;
  font-weight: ${props => (props.light ? '400' : '600')};
  margin: 0px;
  padding: 8px 10px;
  background-color: ${props =>
    props.title ? props.theme.color.wfGrey100 : props.theme.color.wfWhite};
  border-radius: ${props =>
    props.title ? '3px 3px 0 0' : props.last ? '0 0 3px 3px' : '0'};
  border-bottom: ${props =>
    props.last ? 'none' : `1px solid ${props.theme.color.wfGrey200}`};
  line-height: 1.55;
  > a {
    color: ${props => props.theme.color.primary};
    font-weight: 600;
  }
`;
